var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getFetchWrapper } from '@syf-api-library/core';
import { useMutation } from '@tanstack/react-query';
import useConfig from '../context/config.context';
const replaceMultipleCardsEndpoint = 'v1/credit/cards/replace-multiple-cards';
export const useReplaceMultipleCardsQuery = () => {
    const { config } = useConfig();
    const { hosts: { apigee } } = config;
    const mutationFn = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        const fetchWrapper = getFetchWrapper(config);
        return fetchWrapper(`${apigee}${replaceMultipleCardsEndpoint}`, {
            body: JSON.stringify(payload),
            method: 'POST'
        });
    });
    return useMutation({
        mutationKey: [replaceMultipleCardsEndpoint],
        mutationFn
    });
};
//# sourceMappingURL=useReplaceCardQuery.js.map